import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import { Evse } from '@kempoweroyj/ngx-evse-api-client';
import { GlobalSearchConnectorResult } from '@kempoweroyj/ngx-search-api-client';
import { CustomerPrivacyService } from 'layout/customer-privacy/customer-privacy.service';

@Component({
    selector: 'ce-connector-badge',
    templateUrl: './connector-badge.component.html',
    styleUrls: ['./connector-badge.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConnectorBadgeComponent {
    @Input() headerStyle = false;
    @Input() connector: Evse;
    @Input() location: string;
    @Input() globalSearchConnector: GlobalSearchConnectorResult;

    constructor(public customerPrivacy: CustomerPrivacyService) {}
}
